// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"5179ecd2","66":"b8d63d3b","486":"130caf96","570":"315d4014","612":"b8fc7a0b","686":"30dada1e","736":"f8a4030d","973":"66e08feb"}[chunkId] + ".chunk.css";
};